import { useMemo } from 'react';

import { useCalendarEventStateContext, useCalendarStateContext } from '..';

const useSelectedEvent = () => {
  // context
  const { activeEvent } = useCalendarEventStateContext();
  const { events } = useCalendarStateContext();

  // find event from the list
  const event = useMemo(
    () => activeEvent && events.find(item => item.id === activeEvent?.id),
    [activeEvent, events]
  );

  const data = useMemo(() => {
    if (!event || !activeEvent) return null;

    return {
      event,
      ui: activeEvent
    };
  }, [event, activeEvent]);

  return data;
};

export default useSelectedEvent;
